import React, { useEffect, useState } from "react";
import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ReservationGuestInformation from "./ReservationGuestInformation";
import CustomerInformationArea from "./CustomerInformationArea";
import { GetPassengerInformation } from "../../api";
import ReservationsLoading from "../../Loaders/ReservationsLoading";

const GuestModals = ({
  data,
  guestModal,
  setGuestModal,
  setguestLoading,
  open,
  setOpen,
  rez,
  list,
}) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passengerInformationData, setPassengerInformationData] =
    useState(false);

  const cancelButtonRef = useRef(null);
  useEffect(() => {
    if (guestModal) {
      setError(false);
      setLoading(true);
      GetPassengerInformation(data.Token, guestModal)
        .then((result) => {
          if (result.data.error) {
            setError(result.data.error);
            setGuestModal(false);
          } else {
            setOpen(guestModal ? true : false);
            setError(false);
            setPassengerInformationData(result.data);
          }
        })
        .finally((e) => {
          setLoading(false);
        });
    }
  }, [guestModal]);

  useEffect(() => {
    setguestLoading(loading);
  }, [loading]);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="scale-0"
          enterTo="scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto mx-3">
          <div className="flex min-h-full items-center justify-center text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all overflow-y-auto max-h-[calc(100vh-160px)] sm:my-8 sm:w-full sm:max-w-fit ">
                <div className="flex xl:flex-nowrap  flex-wrap bg-white rounded-[30px] 2xl:py-14 py-5 2xl:px-14 px-5">
                  {error ? (
                    <div className="mx-auto">{error}</div>
                  ) : loading ? (
                    <div className="mx-auto">
                      <ReservationsLoading />
                    </div>
                  ) : (
                    <>
                      <CustomerInformationArea
                        passengerInformationData={passengerInformationData}
                      />
                      <div className=" w-full xl:pl-[42px] xl:order-2 order-1">
                        <ReservationGuestInformation
                          setOpen={setOpen}
                          loginData={data}
                          passengerInformationData={passengerInformationData}
                          rez={rez}
                          list={list}
                        />
                        {/* <GuestInformationSuccessfully /> */}
                      </div>
                    </>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default GuestModals;
